<template>
  <div>
    <v-sheet>
      <v-container>
        <tickets-create></tickets-create>
        <tickets-datatable></tickets-datatable>
      </v-container>
    </v-sheet>
    <tickets-listener></tickets-listener>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TicketsDatatable from '@/pages/consumidor_final/DatatableComponent'
import TicketsCreate from '@/pages/consumidor_final/CreateComponent'
import TicketsListener from '@/pages/consumidor_final/ListenerComponent'
export default {
  name: 'ConsumidorFinalMainComponent',
  components: {
    'tickets-datatable': TicketsDatatable,
    'tickets-create': TicketsCreate,
    'tickets-listener': TicketsListener
  },
  data () {
    return {
      dialogCreate: false,
      dialogEdit: false,
    }
  },
  beforeDestroy() {
    this.$store.dispatch('Cuentas/onClearEdited');
    this.$store.dispatch('Cuentas/onClearSelected');
  },
  computed: {
    //
  },
  methods: {
    ...mapActions('Precios', ['onFetch']),
    onCreate (event) {
      event.preventDefault()
      this.dialogCreate = true
    },
    onEdit (event) {
      event.preventDefault()
      this.dialogEdit = true
    },
    onRefresh (event) {
      event.preventDefault()
      this.onFetch()
    }
  }
}
</script>
